<div>
  <app-modal-reservation-generic
    (submitReserve)="addReservationResource($event)"
    (submitEdit)="editReservationResource($event)"
  ></app-modal-reservation-generic>
  <app-modal-error-mobile></app-modal-error-mobile>
</div>
